// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 更新为已读 POST /official_document_org/updateReadFlag/${param0} */
export async function postOfficialDocumentOrgUpdateReadFlagId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.postOfficialDocumentOrgUpdateReadFlagIdParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<Record<string, any>>(`/official_document_org/updateReadFlag/${param0}`, {
    method: 'POST',
    params: { ...queryParams },
    ...(options || {}),
  });
}
